const ip = "http://localhost:8000/";
export default ip;